import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { StyledModalBody, StyledTable } from './index.styles'
import Cookies from 'js-cookie'
import config from '../../../config'


const UserRefereeModal = ({ isOpen, onClose, userId}) => {
  const [referee, setReferee] = useState([])
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const fetchReferee = useCallback(
    async (page) => {
      setIsLoadingMore(true)
      try {
        const response = await fetch(
          `${config.apiAdminGateway}/api/v1/admin/users/${userId}/referee?page=${page}&limit=10`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              Authorization: `Bearer ${Cookies.get('accessToken')}`,
            },
          },
        ).then((res) => res.json())
        setReferee((referee) => (page === 1 ? response.data : [...referee, ...response.data]))
        setPagination((pagination) => ({
          ...pagination,
          hasNext: response.pagination.hasNext,
        }))
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoadingMore(false)
      }
    },
    [userId],
  )

    
  useEffect(() => {
    if (isOpen) {
      fetchReferee(pagination.page)
    }
  }, [fetchReferee, pagination.page, isOpen])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      scrollable
      centered
      enforceFocus={false}
      style={{ background: 'rgba(0,0,0,0.5)' }}
    >
      <Modal.Header closeButton>
        <Modal.Title>ผู้ใช้ที่คุณแนะนำ</Modal.Title>
      </Modal.Header>
      <StyledModalBody>
        <StyledTable>
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>รหัสผู้ใช้</th>
              <th>เวลา / วันที่สมัคร</th>
            </tr>
          </thead>
          <tbody>
            {referee.map((ref, index) => {
              return (
                <tr key={index}>
                  <td style={{ width: '10%' }}>{index + 1}</td>
                  <td>
                    {ref.userNo}
                  </td>
                  <td>{moment(ref.registeredAt).format('HH:mm DD/MM/YYYY')}</td>
                </tr>
              )
            })}
          </tbody>
          <tfoot>
            {isLoadingMore ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </td>
              </tr>
            ) : (
              pagination.hasNext && (
                <tr>
                  <td colSpan={6} className="text-center">
                    <button
                      className="btn btn-primary p-2"
                      onClick={() => {
                        if (pagination.hasNext) {
                          setPagination((pagination) => ({
                            ...pagination,
                            page: pagination.page + 1,
                          }))
                        }
                      }}
                    >
                      โหลดเพิ่มเติม
                    </button>
                  </td>
                </tr>
              )
            )}
          </tfoot>
        </StyledTable>
      </StyledModalBody>
    </Modal>
  )
}

export default UserRefereeModal
